import styles from "./StoryFramesSequence.module.css";
import PixelSentence from "../pixel-text/PixelSentence";
import { useEffect, useState, useRef } from "react";
import { StoryFramesPreloader } from "../../classes/StoryFramesPreloader";

export default function StoryFramesSequence({ onEnter, storyFrames }) {
  const [isReady, setIsReady] = useState(false);
  const [promptIndex, setPromptIndex] = useState(0);
  const loadedImageFramesRef = useRef(null);

  useEffect(() => {
    const startPreloading = async () => {
      const preloader = new StoryFramesPreloader(storyFrames);
      await preloader.init((loadedImageFrames) => {
        loadedImageFramesRef.current = loadedImageFrames;
        setIsReady(true);
      });
    };
    startPreloading();
  }, [storyFrames]);

  const order = loadedImageFramesRef.current;
  if (!isReady) {
    return;
  }

  return (
    <div className={styles.container}>
      <div className={styles.containerInner} key={order[promptIndex].prompt}>
        <img
          className={styles.storyImage}
          src={order[promptIndex].img}
          alt={"Story"}
        />
        <div className={styles.textContainer}>
          <PixelSentence
            centeredText={true}
            textString={order[promptIndex].prompt}
            onDone={() => {
              if (promptIndex === order.length - 1) {
                onEnter();
                return;
              }
              setPromptIndex(promptIndex + 1);
            }}
          />
        </div>
      </div>
    </div>
  );
}
